import React from 'react'
import classNames from 'classnames'
import SVG from 'react-inlinesvg'
import previousIcon from '../../../../images/previous-small-js.svg'
import nextIcon from '../../../../images/next-small-js.svg'

export const SHARED_BUTTON_CLASSNAMES =
  'self-stretch m-1 py-12 bg-crystalline rounded-3 font-bold text-depths tracking-10 uppercase'
const TEXT_BUTTON_CLASSNAMES = 'px-8 sm:px-16 flex-grow'

export function BackButton({ onClick, disabled, isSingleDay }) {
  return (
    <button
      // need to keep these as button types so they don't submit form in tickets app and trigger the next() action
      type="button"
      data-testid="back"
      onClick={onClick}
      disabled={disabled}
      className={classNames(SHARED_BUTTON_CLASSNAMES, 'px-16 leading-none', {
        'cursor-default text-black-22': disabled
      })}
    >
      <SVG
        src={previousIcon}
        className="stroke-current"
        aria-hidden="true"
        aria-label="previous"
      />
      <span className="sr-only">
        Go to Previous {isSingleDay ? 'Day' : 'Week'}
      </span>
    </button>
  )
}

export function CurrentButton({ onClick, disabled, isSingleDay }) {
  return (
    <button
      type="button"
      data-testid="current"
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        SHARED_BUTTON_CLASSNAMES,
        TEXT_BUTTON_CLASSNAMES,
        'sm:flex-no-grow whitespace-nowrap',
        {
          'cursor-default text-black-22': disabled
        }
      )}
    >
      <span className="sr-only">Go to </span>
      {isSingleDay ? 'Today' : 'This Week'}
    </button>
  )
}

export function NextButton({ onClick, disabled, isSingleDay }) {
  return (
    <button
      type="button"
      data-testid="forward"
      onClick={onClick}
      disabled={disabled}
      className={classNames(SHARED_BUTTON_CLASSNAMES, 'px-16 leading-none', {
        'cursor-default text-black-22': disabled
      })}
    >
      <SVG
        src={nextIcon}
        className="stroke-current"
        aria-hidden="true"
        aria-label="next"
      />
      <span className="sr-only">Go to Next {isSingleDay ? 'Day' : 'Week'}</span>
    </button>
  )
}

export function DayViewButton({ onClick, isSingleDay }) {
  return (
    <button
      data-testid="day"
      onClick={onClick}
      className={classNames(SHARED_BUTTON_CLASSNAMES, TEXT_BUTTON_CLASSNAMES, {
        'bg-black-8': isSingleDay
      })}
    >
      <span className="sr-only">Switch to</span>
      Day
      <span className="sr-only">View</span>
    </button>
  )
}

export function WeekViewButton({ onClick, isRange }) {
  return (
    <button
      data-testid="week"
      onClick={onClick}
      className={classNames(SHARED_BUTTON_CLASSNAMES, TEXT_BUTTON_CLASSNAMES, {
        'bg-black-8': isRange
      })}
    >
      <span className="sr-only">Switch to</span>
      Week
      <span className="sr-only">View</span>
    </button>
  )
}
